import hallOverviewCountTypesHelper from "./hall-overview-count-types-helper";

const HallHelpers = {
    OverviewCountTypes : hallOverviewCountTypesHelper
}

export default HallHelpers;